import { render, staticRenderFns } from "./docmanageauthority.vue?vue&type=template&id=1405736d&scoped=true&"
import script from "./docmanageauthority.vue?vue&type=script&lang=js&"
export * from "./docmanageauthority.vue?vue&type=script&lang=js&"
import style0 from "./docmanageauthority.vue?vue&type=style&index=0&id=1405736d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1405736d",
  null
  
)

export default component.exports